import React from "react";
import {
  Alert,
  AlertIcon,
  Box,
  Heading,
  Stack,
  Text,
} from "@chakra-ui/react";
import { AUTH_PROVIDERS, useAuthProvider } from "../Authentication/AuthProviderSwitch";
import { UserProfile } from "../ClerkAuthentication/clerkReact";

const ClientSecurityPage = () => {
  const { provider } = useAuthProvider();

  if (provider !== AUTH_PROVIDERS.CLERK) {
    return (
      <Stack spacing={4}>
        <Box>
          <Heading size="md" mb={2}>Security & Password</Heading>
          <Text color="gray.600" fontSize="sm">
            Client security settings are managed in Clerk.
          </Text>
        </Box>
        <Alert status="warning" borderRadius="md">
          <AlertIcon />
          Client flow requires Clerk authentication. Set `REACT_APP_AUTH_PROVIDER=CLERK` for local testing.
        </Alert>
      </Stack>
    );
  }

  return (
    <Stack spacing={4}>
      <Box>
        <Heading size="md" mb={2}>Security & Password</Heading>
        <Text color="gray.600" fontSize="sm">Manage password, MFA, and account security directly in Clerk.</Text>
      </Box>
      <Box borderWidth="1px" borderColor="gray.200" borderRadius="md" p={{ base: 2, md: 3 }}>
        <UserProfile routing="path" path="/client/security" />
      </Box>
    </Stack>
  );
};

export default ClientSecurityPage;
